import script from "./dummyData11.vue?vue&type=script&lang=js"
export * from "./dummyData11.vue?vue&type=script&lang=js"

const __exports__ = script;

export default __exports__